import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class StatusApi {
  cancelTokens = {
    getStatuses: null,
    getStatus: null,
    setStatus: null,
    destroyStatus: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getStatuses({ page = 1, qtd_por_pagina, nome, codigo, ativo }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      nome,
      codigo,
      ativo,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getStatuses = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/status?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getStatus = null;
    return data;
  }

  async getStatus(statusId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getStatus = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/status/${statusId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getStatus = null;

    return data;
  }

  async destroyStatus(statusId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyStatus = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/status/${statusId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getStatus = null;
    return data;
  }

  async setStatus(status) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.setStatus = source;

    if (status.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/status/${status.id}`,
        {
          cancelToken: source.token,
          ...status,
        }
        /* ).catch(erro => {
        console.log(erro.response);
        return erro;
      } */
      );

      this.cancelTokens.setStatus = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/status`,
        {
          cancelToken: source.token,
          ...status,
        }
        //
      );

      this.cancelTokens.setStatus = null;
      return data;
    }
  }

}

export default StatusApi;
